import {createSlice} from '@reduxjs/toolkit';

const initialState ={
    downloadProgress:0
};


const downloadSlice = createSlice({
    name:"download",
    initialState,
    reducers:{
        setDownloadProgress: (state,action)=>{
            state.downloadProgress = action.payload;
        }
    }
});

export const {setDownloadProgress} = downloadSlice.actions;
export default downloadSlice.reducer;